module.exports = ".padding-default{padding-top:3.5%;padding-left:4%}\n"